export enum ReportingActionTypes {
  GET_REPORTING_TABLE = 'GET_REPORTING_TABLE',
  GET_REPORTING_ACTIVITY = 'GET_REPORTING_ACTIVITY',
}
